import { LandingPageAPISymbol, name } from '../symbols'
import { IModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { withDependencies } from '@wix/thunderbolt-ioc'
import { ILandingPagePageAPI, LandingPageSideEffects } from '../types'

const landingPageHandler = ({
	updateClassNames,
}: ILandingPagePageAPI): IModelUpdatesHandlersImplementor<LandingPageSideEffects> => ({
	featureName: name,
	handlers: {
		onLandingPageUpdate: ({ isLandingPage }) => updateClassNames(isLandingPage),
	},
})

export const LandingPageUpdateHandler = withDependencies([LandingPageAPISymbol], landingPageHandler)
